import { makeStyles } from '@surveycake/rc';

export const useStyles = makeStyles([
  [
    'contentContainer',
    (theme, [type]) => [
      `
			position: relative;
			width: 96%;
			margin-right: 0;
			float: right;

			@media (max-width: 720px) {
				width: 100%;
			}
		`,
      (type === 'QUOTE' || type === 'STATEMENT') &&
        `
			float: none;
			width: 100%;
		`
    ]
  ]
]);
